<template>
  <v-container>
    <DesktopTopPart />
    <v-row>
      <v-col class="white px-0">
        <v-container fluid>
          <v-row>
            <v-col class="grow">
              <PaymentForm />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <PageFooter />
    </v-row>
  </v-container>
</template>

<script>
import DesktopTopPart from '@/components/Views/Layout/DesktopTopPart'
import PageFooter from '@/components/App/_PageFooter'
import state from '@/store/state'
import sharedComputed from '@/methods/sharedComputed'
import { createHelpers } from 'vuex-map-fields'
import sharedMethods from '@/methods/sharedMethods'
import articleComputed from '@/methods/articleComputed'
import PaymentForm from '@/components/PaymentForm.vue'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'PaymentFormDesktop',

  props: {
    id: {
      type: String,
      default: null,
    },
  },

  components: {
    PaymentForm,
    PageFooter,
    DesktopTopPart,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...articleComputed,

  },

  methods: {
    ...sharedMethods,
  },
}
</script>
